var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDxd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.65 2.828 18.48 5.725c-.542-.181-2.208-.435-4.525 0-2.897.543-6.156 2.354-8.058 6.246-1.52 3.116-.271 7.153 1.358 10.231l4.255-3.982 2.445 2.354-7.062 6.7c-1.69-1.51-5.033-5.958-4.888-11.68.18-7.151 3.892-9.867 7.333-11.95 4.144-2.508 9.928-1.599 12.312-.814zM10.333 29.172l3.17-2.897c.542.181 2.208.435 4.525 0 2.898-.543 6.157-2.354 8.058-6.246 1.52-3.116.271-7.153-1.358-10.231l-4.255 3.982-2.444-2.354 7.06-6.7c1.69 1.51 5.034 5.958 4.889 11.68-.182 7.151-3.894 9.867-7.334 11.95-4.145 2.508-9.929 1.599-12.313.814zm.906-15.843-2.355-1.992 2.173-2.354 2.354 2.354-2.173 1.991zm2.352 2.806 2.354 1.992 2.173-1.992-2.355-2.354-2.173 2.354zm7.062 6.7L18.3 20.842l2.173-2.353 2.354 2.353-2.173 1.992z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxd);
export default __webpack_public_path__ + "static/media/DXD.373f7f2df6a4aad161eb46e3c76ec210.svg";
export { ForwardRef as ReactComponent };